/**
 * Taxes API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createTax,
  deleteTax,
  getTaxes,
  permanentDeleteTax,
  replaceTax,
  restoreTax,
  updateTax,
} from "../generated/taxes/taxes";

import { wrapListMethod, wrapMethod } from "./utils";

export const taxes = {
  /** @see createTax */
  create: wrapMethod(createTax),

  /** @see getTaxes */
  list: wrapListMethod(getTaxes),

  /** @see updateTax */
  update: wrapMethod(updateTax),

  /** @see replaceTax */
  replaceTax: wrapMethod(replaceTax),

  /** @see deleteTax */
  delete: wrapMethod(deleteTax),

  /** @see restoreTax */
  restoreTax: wrapMethod(restoreTax),

  /** @see permanentDeleteTax */
  permanentDeleteTax: wrapMethod(permanentDeleteTax),
} as const;

export type TaxesApi = typeof taxes;
